import { useSelector } from 'react-redux';
import { selectors } from 'store/home';
import { SalesAppointmentContainer } from './salesappointmentcontainer';
import { FollowUpAppointmentContainer } from './followupappointmentcontainer';

export const AppointmentContainer = (props: { id: string; showDate?: boolean }) => {
	const appointment = useSelector(selectors.getAppointment(props.id));

	if (!appointment) return null;

	if (appointment.isModernFollowUp) {
		return <FollowUpAppointmentContainer id={props.id} showDate={props.showDate} />;
	}

	return <SalesAppointmentContainer id={props.id} showDate={props.showDate} />;
};
